module.exports = asciimathAccents = [
  'hat',
  'bar',
  'ul',
  'vec',
  'dot',
  'ddot',
  'ubrace',
  'obrace',
];